module.exports = __webpack_public_path__ + "img/maisonette-6.cfe780e7.webp";